import React, { useState } from 'react';
import { LOGO_URL } from '../data/content';
import { legalDocuments } from '../data/legal';
import { LegalModal } from './LegalModal';
type LegalKey = 'privacy' | 'terms';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalKey | null>(null);
  return <footer className="w-full bg-ink-900 py-12" data-id="element-81" data-mp="36p6bgupomqa3">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 sm:grid-cols-3" data-id="element-82" data-mp="36pzeplpfmxnh">
        <div className="flex items-start gap-3" data-id="element-83" data-mp="3ug3efhzi2d97">
          <img src={LOGO_URL} alt="" className="h-14 w-14 object-contain" data-id="element-84" data-mp="3ud7i1y3avwmv" />
          <div data-id="element-85" data-mp="37xyao5wgelp">
            <p className="font-display text-lg uppercase text-white" data-id="element-86" data-mp="36mr0ed8wopu">Javier&apos;s Junk Removal</p>
            <p className="text-sm text-white/70" data-id="element-87" data-mp="3lggfd2u8tjjb">
              North County&apos;s Local Junk Removal Solution
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-10 flex max-w-6xl flex-col gap-4 border-t border-white/10 px-5 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-88" data-mp="29yds9o7gci43">
        <p className="font-display text-sm uppercase tracking-[0.18em] text-white/60" data-id="element-89" data-mp="3l9adtjp9964y">
          Local • Reliable • Transparent
        </p>
        <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-90" data-mp="3gbr0cm0dsxe2">
          {(['privacy', 'terms'] as LegalKey[]).map(key => <button key={key} type="button" onClick={() => setOpenDoc(key)} className="rounded text-sm font-semibold text-white/70 underline decoration-ember-500 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ember-500" data-id="element-91" data-mp="3v919vptgrt75">
              {legalDocuments[key].title}
            </button>)}
        </nav>
      </div>

      <LegalModal document={openDoc ? legalDocuments[openDoc] : null} onClose={() => setOpenDoc(null)} data-id="element-92" data-mp="huwhyvt6vz5r" />
    </footer>;
}